export const formatRp = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "Rp0";
  return "Rp" + Math.round(n).toLocaleString("id-ID");
};

const MONTH_ID = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export const formatDateID = (s) => {
  if (!s) return "-";
  const d = new Date(s.length <= 10 ? s + "T00:00:00" : s);
  if (isNaN(d.getTime())) return s;
  return `${d.getDate()} ${MONTH_ID[d.getMonth()]} ${d.getFullYear()}`;
};

export const formatDateTimeID = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${d.getDate()} ${MONTH_ID[d.getMonth()]} ${d.getFullYear()}, ${hh}:${mm}`;
};

export const todayISO = () => {
  // Jakarta local date in YYYY-MM-DD
  const now = new Date();
  const jakarta = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Jakarta" }));
  const y = jakarta.getFullYear();
  const m = String(jakarta.getMonth() + 1).padStart(2, "0");
  const d = String(jakarta.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const statusLabel = {
  draft: "Draf",
  diajukan: "Diajukan",
  dikonfirmasi: "Dikonfirmasi",
  dikembalikan: "Dikembalikan",
};

export const statusColor = {
  draft: "bg-slate-100 text-slate-700",
  diajukan: "bg-amber-100 text-amber-800",
  dikonfirmasi: "bg-emerald-100 text-emerald-800",
  dikembalikan: "bg-red-100 text-red-800",
};

export const periodStatusLabel = {
  belum_dimulai: "Belum dimulai",
  berlangsung: "Berlangsung",
  selesai: "Selesai",
};

export const sourceLabel = {
  alumni: "Alumni",
  orang_tua: "Orang tua",
  umum: "Umum",
  lainnya: "Lainnya",
};

export const categoryLabel = {
  ruang_baca: "Ruang baca",
  kebun: "Kebun mini",
  cadangan: "Cadangan",
  pendukung: "Pendukung",
};
